import PhotoSwipeLightbox from 'photoswipe/lightbox';

import 'photoswipe/style.css';

export default function () {
    const lightbox = new PhotoSwipeLightbox({
        gallery: '#photoswipe-gallery',
        children: 'a',
        pswpModule: () => import('photoswipe'),
    });
    lightbox.init();

    const galleries = new PhotoSwipeLightbox({
        gallery: '.photoswipe-gallery',
        children: 'a',
        pswpModule: () => import('photoswipe'),
    });
    galleries.init();

    const individuals = new PhotoSwipeLightbox({
        gallery: 'a.photoswipe',
        pswpModule: () => import('photoswipe'),
    });
    individuals.init();
}
